import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles({
  danger: {
    color: '#f44336!important',
    fontSize: '11px !important',
    fontWeight: 500,
  },
});

const ErrorMessage = ({ children, style }: any) => {
  const classes = useStyles();
  return (
    <div className={classes.danger} style={style}>
      {children}
    </div>
  );
};

export default ErrorMessage;
